module.exports = __webpack_public_path__ + "img/paypal.01e96e1.svg";